import { render, staticRenderFns } from "./TourPlacementCombinationItem.vue?vue&type=template&id=6cc1971b"
import script from "./TourPlacementCombinationItem.vue?vue&type=script&lang=js"
export * from "./TourPlacementCombinationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports